import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { hasChanges as baseHasChanges } from "@insite/client-framework/Store/Pages/AccountSettings/AccountSettingsSelectors";
import StoreApplicationState, { getStoreApplicationState } from "@store/Store/StoreApplicationState";

export function getAccountSettingsState(state: ApplicationState | StoreApplicationState) {
    return getStoreApplicationState(state).store.pages.accountSettings;
}

export function hasChanges(state: ApplicationState) {
    const { editingAccount, preferredDefaultLanguage } = getAccountSettingsState(state);
    const account = getCurrentAccountState(state).value;
    if (!account || !editingAccount) {
        return false;
    }
    
    return (
        account.firstName !== editingAccount.firstName ||
        account.lastName !== editingAccount.lastName ||
        ((account.properties.preferredDefaultLanguage || "") !== preferredDefaultLanguage) ||
        baseHasChanges(state)
    );
}

export function customFieldsAreValid(state: ApplicationState) {
    const accountSettingsState = getAccountSettingsState(state);

    return (
        !accountSettingsState.firstNameErrorMessage &&
        !accountSettingsState.lastNameErrorMessage
    )
}
